import styled from "styled-components";
import { useAuth } from "../../contexts/AuthContext";
import { TitleText, MetaText } from "../atoms/Text";
import { NavItem } from "../atoms/NavItem";

const Wrapper = styled.header`
  /* 高さと横余白 */
  height: 56px;
  padding: 0 16px;

  /* 中身の配置 */
  display: flex;
  align-items: center;
  justify-content: space-between;

  /* 見た目（背景・境界線） */
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;

  /* 上に固定したい場合は以下を有効化（任意）
  position: sticky;
  top: 0;
  z-index: 10;
  */
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const User = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 12px;
  border-left: 1px solid #C2C8CF;
`;

export function GlobalHeader() {
  const { user } = useAuth();

  return (
    <Wrapper>
      <Left>
        <TitleText>展示会受付システム</TitleText>
      </Left>

      <Right>
        <Nav>
          <NavItem to="/" end>ホーム</NavItem>
          <NavItem to="/scan">受付</NavItem>
          <NavItem to="/list">来場者状況</NavItem>
        </Nav>
        <User>
          <MetaText>{user?.email || "-"}</MetaText>
        </User>
      </Right>
    </Wrapper>
  );
}